module.exports = __webpack_public_path__ + "static/img/81123D_1_2_R_20220718_LC.c9ef548.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/81123D_1_2_R_20220718_LC.png
// module id = qH/S
// module chunks = 0